module.exports = __webpack_public_path__ + "img/empty.45a2c875.png";